import React, { ReactNode, useEffect } from "react";

export interface SquareProps {
  children?: ReactNode;
}

function Square(props: SquareProps) {
  const { children } = props;

  const container = React.createRef<HTMLDivElement>();
  const [dimension, setDimension] = React.useState<{ size: number }>();

  useEffect(() => {
    if (container.current) {
      setDimension({
        size: container.current.offsetWidth,
      });
    }
  }, []);
  return (
    <div ref={container}>
      {dimension && <div style={{ position: "relative", height: dimension.size }}>{children}</div>}
    </div>
  );
}

export default Square;
